import React from 'react';
import styled from 'styled-components';
const Container = styled.span `
  position: relative;
  display: table;
  height: 100%;
  margin: 0 auto;
  padding: ${({ topBottomOffset }) => (!!topBottomOffset ? `${topBottomOffset}px 0px` : '20px 0px')};
`;
const TabIndicator = styled.span `
  background-color: ${({ theme }) => theme.primaryRed};
  position: absolute;
  bottom: 0;
  left: 0;
  height: 4px;
  width: 100%;
`;
export const TextWithIndicator = ({ children, isSelected, topBottomOffset }) => {
    return (React.createElement(Container, { topBottomOffset: topBottomOffset },
        children,
        isSelected && React.createElement(TabIndicator, null)));
};
